import { Tooltip } from "antd";
import { useRef,useState,useEffect } from "react";
import "./OverflowText.css";

export const OverflowText = ({
  text,
  className,
}) => {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;

    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const content = (
    <div ref={ref} className={`overflow-text ${className}`}>
      {text}
    </div>
  );

  return isOverflowing ? (
    <Tooltip title={text}
        placement="topLeft"
        alignPoint
        color="#7509B8"
        getPopupContainer={() => document.body}   
        zIndex={999999} 
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};